export default class PopPlugins {
	constructor(name, vueConstructor) {
		this.instance = null;
		this.pluginName = name;
		this.vueConstructor = vueConstructor;
		this.init();
	}
	init() {
		if (!this.vueConstructor || typeof this.vueConstructor != 'function') {
			console.error('初始化插件失败');
			return false;
		}
		if (!this.instance) {
			this.instance = new this.vueConstructor({
				el: document.createElement('div')
			});
			document.body.appendChild(this.instance.$el);
		} else {
			console.warn(`已初始化${this.pluginName}实例，请勿重复初始化`);
		}
	}
	show() {
		if (!this.instance.visiable) {
			this.instance.visiable = true;
		}
	}
	hide() {
		if (this.instance.visiable) {
			this.instance.visiable = false;
		}
	}
	destroy() {
		if (this.instance) {
			document.body.removeChild(this.instance.$el);
			this.instance = null;
		} else {
			console.error(`未初始化${this.pluginName}实例`);
		}
	}
}